import { Icon, IconProps } from './Icon';

export type PlayProps = IconProps;

export const Play = (props: PlayProps) => (
  <Icon width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M4.167 4.158c0-.81 0-1.214.168-1.437a.833.833 0 0 1 .615-.33c.28-.016.616.209 1.29.658l8.763 5.842c.556.37.834.556.931.79a.833.833 0 0 1 0 .638c-.097.234-.375.42-.931.79L6.24 16.951c-.674.45-1.01.674-1.29.657a.833.833 0 0 1-.615-.33c-.168-.222-.168-.627-.168-1.436V4.158Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
